import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Button from '../../components/Button';
import { actions } from '../../store/reducers/authentication';
import { getRedirectPath } from "../../constants/user";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { AuthenticationService } from "../../services";
import AuthLayout from "../../components/Layout/AuthLayout";
import Redirect from "../../components/Redirect";
import { useApp } from "../../helpers/user";
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";

const mstp = ({ authentication }) => ({ authentication });
const step = 1;

const Confirm = ({ authentication: { user }, exitImpersonation, logout, resendVerification }) => {
  const app = useApp();
  const { t } = useTranslation();
  const [hasPrevious, setPrevious] = useState(false);

  const resendEmail = async () => {
    try {
      message.info('Sending email...');
      const res = await AuthenticationService.resendEmail();

      if (res && res.data) {
        message.success('Email resend successfully');
        return;
      }
      throw new Error('');
    } catch (err) {
      message.error('Error sending email');
    }
  };

  useEffect(() => {
    if (localStorage.getItem('previous')) {
      setPrevious(true);
    }
  }, [])

  const onLogOff = () => {
    StorageManager.clearOne('token');
    if (app === 'mmt') {
      window.location.href = '/login'
    } else {
      window.location.href = `/${app}/login`;
    }
  }

  const getLogo = () => {
    switch (app) {
      case 'tif':
        return 'verified-user-tif';
      case 'tazama':
        return '';
      default:
        return 'verified-user';
    }
  }

  const getLink = () => {
    switch (app) {
      case 'tif':
        return 'https://www.theimpactfacility.com/about-us/contact-us/';
      default:
        return 'mailto:support@datastake.io';
    }
  };

  return (!user?.emailVerified || user?.approvalStatus === 'pending') ? (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>

      {hasPrevious ? (
        <div className="confirmMessage">
          <h4>
            {t("This user")},
            <br></br>
            {t("has not confirmed his email address yet")}.
            <br></br>
            <Button onClick={exitImpersonation} style={{ margin: '20px', marginBottom: 0, width: 'calc(100% - 40px)' }} type="primary">{t("Exit impersonation")}</Button>
            <Button
              onClick={resendEmail}
              style={{ margin: '20px', width: 'calc(100% - 40px)' }}
            >
              {t("Resend confirmation link")}
            </Button>
          </h4>
        </div>
      ) : (
        <AuthLayout
          step={step}
          rightClassName={
            user?.emailVerified ? getLogo() : undefined
          }
          title={user?.emailVerified ? 'Your email has been successfully verified' : 'Application under review'}
          app={app}
          subTitle={(
            <>
              {user?.emailVerified ? (
                <>
                  {t("Now, kindly await the administrator's response to activate your account.")}
                  <br />
                  <br />
                  <span>
                    {t('Do you still have questions?')}
                    {' '}
                    <a
                      href={getLink()}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t('Get In contact')}
                    </a>
                  </span>
                  <br />
                  <span>
                    {t('Need to log in with another account?')}
                    {' '}
                    <a onClick={onLogOff}>
                      {t('Log off')}
                    </a>
                  </span>
                </>
              ) : (
                <>
                  {t('Thank you for applying for a MMT account.')}
                  <br />
                  <br />
                  {t('confirmText3')}
                  <br />
                  <br />
                  {!user?.emailVerified && (<Button
                    className="normal-br"
                    onClick={resendEmail}
                    style={{ marginBottom: 20 }}
                  >
                    {t("Resend confirmation link")}
                  </Button>)}
                  <Button
                    className="normal-br"
                    onClick={() => {
                      logout(() => {
                        setTimeout(() => {
                          window.location.href = process.env.REACT_APP_LANDING_PAGE_URL;
                        }, 200);
                      });
                    }}
                    type="primary"
                  >
                    {t("Back to website")}
                  </Button>
                </>
              )}

            </>
          )}
        />
      )}
    </div>
  ) : <Redirect to={getRedirectPath(user)}></Redirect>
};

export default connect(mstp, actions)(Confirm);
